import React, { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { PrimaryButton } from "./Buttons.jsx";
import { useNavigate } from "react-router-dom";
import PlanModal from "../partials/planModal/PlanModal.jsx";

const PremiumPaywall = ({
  blockScroll = true,
  requiresAddon = [],
  requiresPlan = [],
  dismissAction = null,
}) => {
  const { selectedMerchant, mainContainer } = useSelector((state) => state.app);
  const [isPlanModalOpen, setIsPlanModalOpen] = React.useState(false);
  const navigate = useNavigate();

  const satisfied = useMemo(() => {
    if (!selectedMerchant) return false;
    if (requiresAddon.length === 0 && requiresPlan.length === 0) return true;

    return (
      requiresAddon.some((addon) =>
        selectedMerchant?.direct_addons?.includes(addon)
      ) ||
      requiresPlan.some(
        (plan) => selectedMerchant?.direct_subscription === plan
      )
    );
  }, [selectedMerchant]);

  useEffect(() => {
    if (!mainContainer) return;
    if (!blockScroll) {
      mainContainer.classList.remove("overflow-y-hidden");
      return;
    }
    mainContainer.scrollTo(0, 0);
    if (!satisfied) {
      mainContainer.classList.add("overflow-y-hidden");
    } else {
      mainContainer.classList.remove("overflow-y-hidden");
    }
    return () => {
      mainContainer.classList.remove("overflow-y-hidden");
    };
  }, [satisfied, mainContainer]);

  const requirementFriendly = useMemo(() => {
    const addOnFriendly = {
      "seo-boost": "SEO Boost",
      crm: "Customer Engagement",
    };
    const subscriptionFriendly = {
      growth: "Growth",
    };

    const addOns = requiresAddon
      .map((addon) => addOnFriendly[addon] + " add-on")
      .filter(Boolean);
    const plans = requiresPlan
      .map((plan) => subscriptionFriendly[plan] + " subscription plan")
      .filter(Boolean);

    return [...addOns, ...plans].join(", ").replace(/, ([^,]*)$/, " or $1");
  }, [requiresAddon, requiresPlan]);

  useEffect(() => {
    if (!mainContainer) return;
    if (!blockScroll) {
      mainContainer.classList.remove("overflow-y-hidden");
      return;
    }
    mainContainer.scrollTo(0, 0);
    if (!satisfied) {
      mainContainer.classList.add("overflow-y-hidden");
    } else {
      mainContainer.classList.remove("overflow-y-hidden");
    }
    return () => {
      mainContainer.classList.remove("overflow-y-hidden");
    };
  }, [satisfied, mainContainer]);

  if (!selectedMerchant) return null;

  return (
    !satisfied && (
      <div
        className={
          "absolute inset-0 bg-black dark:bg-theme-surface-accent bg-opacity-65 z-50"
        }
      >
        <div className={"absolute inset-0  flex items-center justify-center"}>
          <div
            className={
              "bg-white dark:bg-theme-surface-accent p-4 rounded-lg flex flex-col items-center gap-4"
            }
          >
            <div className="relative w-full">
              <h2 className={"text-lg font-bold text-center"}>Upgrade now</h2>
              <button
                className={"text-2xl absolute top-[-0.5em] right-1"}
                onClick={() => {
                  // navigate back
                  if (dismissAction) {
                    dismissAction();
                  } else {
                    navigate(-1);
                  }
                }}
              >
                &times;
              </button>
            </div>
            <p className={"text-sm"}>
              This feature requires {requirementFriendly}. Upgrade now to unlock
              this feature.
            </p>
            <PrimaryButton
              onClick={() => {
                setIsPlanModalOpen(true);
              }}
            >
              See Details
            </PrimaryButton>
          </div>
        </div>
        <PlanModal isOpen={isPlanModalOpen} setIsOpen={setIsPlanModalOpen} />
      </div>
    )
  );
};

export default PremiumPaywall;
